import React from 'react'

function CircleTick({ width = "14", height = "14", classname }) {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} className={classname} viewBox="0 0 14.056 14.056">
            <path id="Vector_-_2025-02-17T153550.367" data-name="Vector - 2025-02-17T153550.367" d="M3.764,7.028l2.8,2.331L10.292,4.7M7.028,13.556a6.528,6.528,0,1,1,4.616-1.912A6.529,6.529,0,0,1,7.028,13.556Z" fill="none" stroke="#fff" strokeWidth="1" />
        </svg>
    )
}

export default CircleTick